"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Utilities
var effect_code_1 = require("./effect-code");
var csi_code_1 = require("./csi-code");
var sgr_code_1 = require("./sgr-code");
var tokenize = function (str) {
    var result = [];
    if (str.length === 0) {
        return [['text', str]];
    }
    var res;
    while (str.length > 0) {
        res = effect_code_1.default(str);
        if (res.result.length > 0) {
            result = result.concat(res.result);
            str = res.left;
        }
        else {
            res = csi_code_1.default(str);
            if (res.result.length > 0) {
                result = result.concat(res.result);
                str = res.left;
            }
            else {
                res = sgr_code_1.default(str);
                if (res.result.length > 0) {
                    result = result.concat(res.result);
                    str = res.left;
                }
                else {
                    result.push(['text', str]);
                    break;
                }
            }
        }
    }
    return result;
};
exports.default = tokenize;
//# sourceMappingURL=index.js.map